import React from 'react';
import { Clock, Award, CheckCircle, Shield } from 'lucide-react';
export function WhyChooseUsSection() {
  const reasons = [{
    title: '24/7 Emergency Service',
    description: "We're available around the clock to address urgent maintenance issues whenever they arise.",
    icon: Clock
  }, {
    title: 'Licensed Professionals',
    description: 'Our team consists of certified experts with years of experience in building maintenance.',
    icon: Award
  }, {
    title: 'Quality Guarantee',
    description: 'We stand behind our work with a satisfaction guarantee on all services we provide.',
    icon: CheckCircle
  }, {
    title: 'Fully Insured',
    description: 'Complete peace of mind with our comprehensive insurance coverage for all projects.',
    icon: Shield
  }];
  return <section id="why-us" className="py-16 md:py-24 bg-gray-900 text-white" data-id="element-220">
      <div className="container mx-auto px-4" data-id="element-221">
        <div className="text-center mb-12" data-id="element-222">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-223">Why Choose Us</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto" data-id="element-224"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-225">
          {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return <div key={index} className="text-center p-6" data-id="element-226">
                <div className="bg-amber-500 text-white p-4 rounded-full inline-block mb-4" data-id="element-227">
                  <Icon size={28} data-id="element-228" />
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-229">{reason.title}</h3>
                <p className="text-gray-300" data-id="element-230">{reason.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}